import comp from "./SelectDateTime";

export default comp;
